// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"318":"af25b7e2","537":"70ece0cd","997":"efba33f1"}[chunkId] + ".chunk.css";
};